import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { API,MODAL_MESSAGES } from '../shared/constants';

import { FormMediaComponent } from '../shared/';

import { AlertService } from '../core/alert/alert.service';

import { CheckboxValidators, TextValidators } from '../core';

import { LoginImageService } from './loginimage.service';
import { LoginImage } from './loginimage.model';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Component({
  selector: 'cms-loginImage-form',
  templateUrl: './loginimage.component.html',
  providers: [
    LoginImageService
  ]
})
export class LoginImageComponent implements OnInit {

  // Translation variables

  editText: string;
  editTitle: string;
  addText: string;
  addTitle: string;
  errorText: string;
  errorTitle: string;
  deleteText: string;
  deleteTitle: string;

  @ViewChild(FormMediaComponent) private formMedia: FormMediaComponent;
  medias: Array<any>;
  isMediasDone: boolean;

  mediaUrl: string = API.ENDPOINT.MEDIA.GET;

  title: string;
  entity: any = {
    id: '',
    type: 'loginImage'
  };

  loginimageForm: FormGroup;
  isEditing: boolean;
  isSubmitted: boolean = false;
  isDeleted: boolean = false;

  isSavingData = false;
  hasMedia: boolean = false;
  selectedImage: LoginImage = new LoginImage();

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private loginImageService: LoginImageService,
    private translator: TranslateService,
  ) { }

  ngOnInit() {
    this.translateMessage();
    this.isEditing = false;
    this.title = 'Alterar imagem do Login';
    this.isMediasDone = false;
    let title;

    this.createImage()

    this.loginimageForm = this.fb.group({
      'title' : [title,
                 Validators.compose([Validators.minLength(3), Validators.maxLength(80)])]
    });
  }
  /*
   * Promise 1 - Verify if there's LoginImage document already created
   * Promise 2 - Call persist method to create LoginImage document
   *
  */
  translateMessage(){
    this.translator.get('modal').subscribe((res) => {
      this.editText = res.messages['edit-text'];
      this.editTitle = res.messages['edit-title'];
      this.addText = res.messages['add-text'];
      this.addTitle = res.messages['add-title'];
      this.errorText = res.messages['error-text'];
      this.errorTitle = res.messages['error-title'];
      this.deleteText = res.messages['delete-text'];
      this.deleteTitle = res.messages['delete-title'];
    });

  }
  createImage() {
    this.loginImageService
    .getLoginImage()
    .then((loginimage) => {
      if(loginimage.loginimage != "") {
        this.routeSubscribe(loginimage);
      } else {
        this.loginImageService
        .addLoginImage()
        .then((doc) => {
          this.routeSubscribe(doc);
        })
      }
    });
  }
  /*
   * Set default values (Entity, title, selectImage and medias)
   *
  */
  routeSubscribe(data) {
    this.isEditing = true;
    this.entity.id = data.loginimage._id;
    this.selectedImage = data.loginimage;
    this.medias = data.loginimage.midias;
    this.formMedia.onMediaLoaded(data.loginimage.midias);
    if (this.medias.length > 0)
      this.hasMedia = true;
      this.isMediasDone = true;
  }

  canDeactivate(): Promise<boolean>|boolean {
    if ((this.loginimageForm.dirty) &&
        !this.isSubmitted) {

      return this.alertService
        .activate()
        .then((response) => {
          if (response) {
            //If is adding a news, so delete it
            if(!this.isEditing && !this.isSubmitted){
              this.deleteTempImage();
            }
          }
          return response;
        });
    } else {
      //If is adding a news, so delete it
      if(!this.isEditing && !this.isSubmitted){
        this.deleteTempImage();
      }
    }

    return true;
  }

  submitForm(value: any, valid:any) {
    this.isSavingData = true;

    value._id = this.selectedImage._id
    value.title = this.title;
    value.midias = this.deepClone(this.medias);
    value.midias.forEach((midia) => {
      if (midia.base64) {
        delete midia.base64;
      }
      if (midia.frameBase64) {
        delete midia.frameBase64;
      }
    });

    if (valid) {
      this.loginImageService
        .updateLoginimage(value)
        .then((res) => {
          let message = this.addTitle;
          let title = this.addText;
          let okText = 'OK';

          if (res.serviceStatus.code <= 0) {
            this.isSubmitted = true;

            if (this.isEditing) {
              message = this.editText;
              title = this.editTitle;
            }
          } else {
            this.isSubmitted = false;
            message = this.errorText;
            title = this.errorTitle;
          }

          this.alertService
            .activate(message, title, okText, '')
            .then((response) => {
              if (response) {
                this.goToList();
              }
            });
          this.isSavingData = false;
        });
    }
  }

  deepClone(oldArray: Object[]) {
    let newArray: any = [];
    oldArray.forEach((item) => {
      newArray.push(Object.assign({}, item));
    });
    return newArray;
  }

  askDeleteConfirmation() {
    let message = this.deleteText;
    let title = this.deleteTitle;

    this.alertService
      .activate(message, title)
      .then((response) => {
        if (response) {
          this.deleteNews();
        }
      });
  }

  deleteNews() {
    this.loginImageService
      .deleteLoginimage(this.selectedImage._id)
      .then((res) => {
        if (res.serviceStatus.message == 'Success') {
          this.isDeleted = true;
          this.goToList();
        }
      });
  }

  deleteTempImage() {
    this.loginImageService
      .deleteLoginimage(this.selectedImage._id)
      .then((res) => {
        if (res.serviceStatus.message == 'Success') {
          this.isDeleted = true;
        }
      });
  }

  goToList() {
    this.router.navigate(['/news']);
  }

  onUpdatedMedia(medias: any[]) {
    this.medias = medias;
    this.isMediasDone = true;

    if (this.medias.length > 0)
      this.hasMedia = true;
    else
      this.hasMedia = false;
  }

  onAddedMedia(type: string) {
    this.isMediasDone = false;
  }

  onDroppedMedia(type: string) {
    this.loginimageForm.markAsDirty();
  }

  showPreview() {
    if (this.hasMedia == true) {
      let message = "";
      let title = "Demonstração Login";

      this.alertService
        .activate(message, title,'OK','', this.mediaUrl+this.medias[0].fileName, false, true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/loginImage/loginimage.component.ts